import request from '@/utils/request'
import requestOnlyVerifyToken from '@/utils/requestOnlyVerifyToken'

// 查询用户列表
export function listUser(data) {
  return request({
    url: '/SystemBase/SysUser/Search',
    method: 'post',
    data: data
  })
}

// 查询用户详细
export function UserDetail(userId) {
  return request({
    url: '/SystemBase/SysUser/UserDetail?userId=' + userId,
    method: 'post'
  })
}

// 添加用户
export function UserAdd(data) {
  return request({
    url: '/SystemBase/SysUser/UserAdd',
    method: 'post',
    data: data
  })
}

// 修改用户
export function UserUpdate(data) {
  return request({
    url: '/SystemBase/SysUser/UserUpdate',
    method: 'post',
    data: data
  })
}

// 删除用户
export function UserDelete(userId) {
  return request({
    url: '/SystemBase/SysUser/UserDelete?id=' + userId,
    method: 'post'
  })
}

// 修改密码
export function UserPasswordUpdate(data) {
  return request({
    url: '/SystemBase/SysUser/UserPasswordUpdate',
    method: 'post',
    data: data
  })
}


export function importUser(data) {
  return request({
    url: '/SystemBase/SysUser/ImportUser',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: data
  })
}


export function importOutUser(data) {
  requestOnlyVerifyToken({
    url: '/SystemBase/SysUser/ImportOutUser',
    method: 'post',
    data: data,
    responseType: "blob" 
  }).then((resp) => 
    {
        let blob = new Blob([resp.data], {type: "application/vnd.ms-excel;"}); // 为blob设置文件类型，这里以.xlsx为例
            let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
            let a = document.createElement("a");
            a.href = url;
            a.download = '用户列表';
            a.click();
            // 释放这个临时的对象url
            window.URL.revokeObjectURL(url); 
            //return resp;

    }
    );
}


